<template>
  <ExternalList
      endpoint="/api/v2/publications"
      :endpoint-filters="{publication_channel_id: publicationBasedChannel.id}"
      :headlines=" [{width: 10, text: 'Name'}, {width: 10, text: 'Publication Date'}]"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      :default-page-size="10"
      @show="publication => $router.push('/publications/' + publication.id)"
  >
    <template v-slot:default="{ row: publication }">
      <td>
        <router-link :to="'/publications/' + publication.id">
          {{ publication.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ publication.attributes.publish_at | date }}
      </td>
    </template>

    <template v-slot:modals="{ load, update }">
      <ImportModal :publicationBasedChannel="publicationBasedChannel" @created="load"/>
    </template>
  </ExternalList>
</template>

<script>
import ImportModal from '../Modals/Import'
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {ImportModal, ExternalList},

  props: {
    publicationBasedChannel: {
      required: true
    }
  }
}
</script>
